$(document).ready(function(){

    let p1Swiper = new Swiper('.p1Swiper', {
        // autoplay: true,//可选选项，自动滑动
        parallax:true,
        pagination: {
            el: '.swiper-pagination',
          },
          navigation: {
            nextEl: '.rightButton',
            prevEl: '.leftButton',
          },
    })

    //动效
    $('.imgList .item').on('mouseenter',function(){
        $(this).transition({scale:1.05},200)
     })
     $('.imgList .item').on('mouseleave',function(){
        $(this).transition({scale:1},200)
     })
})
